import React, { Component, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserRoleOptions } from "../../constants/userRole";

const title = "Filter Search Member";
const desc =
  "Serious Dating With HotAdultHub Your Perfect Match is Just a Click Away.";

const FilterSearchSection = () => {
  const navigate = useNavigate();

  // State for form values
  const [formData, setFormData] = useState({
    gender: "",
    lookingFor: "",
    ageStart: "18",
    ageEnd: "30",
    // city: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // navigate to /members and pass form data via state
    navigate("/members", { state: formData });
  };

  return (
    <div>
      <div className="widget search-widget">
        <div className="widget-inner">
          <div className="widget-title">
            <h5>{title}</h5>
          </div>
          <div className="widget-content">
            <p>{desc}</p>
            <form className="banner-form" onSubmit={handleSubmit}>
              <div className="gender">
                <div className="custom-select right w-100">
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                  >
                    <option value="">I am</option>
                    {UserRoleOptions.map(({ value, label }) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="person">
                <div className="custom-select right w-100">
                  <select
                    name="lookingFor"
                    value={formData.lookingFor}
                    onChange={handleChange}
                  >
                    <option value="">Looking For</option>
                    {UserRoleOptions.map(({ value, label }) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="age">
                <div className="right d-flex justify-content-between w-100">
                  <div className="custom-select">
                    <select
                      name="ageStart"
                      value={formData.ageStart}
                      onChange={handleChange}
                    >
                      {[...Array(13)].map((_, i) => {
                        const age = 18 + i;
                        return (
                          <option key={age} value={age}>
                            {age}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="custom-select">
                    <select
                      name="ageEnd"
                      value={formData.ageEnd}
                      onChange={handleChange}
                    >
                      {[...Array(13)].map((_, i) => {
                        const age = 18 + i;
                        return (
                          <option key={age} value={age}>
                            {age}+
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="city">
                {/* <div className="custom-select right w-100">
                  <select className="">
                    <option value="0">Choose Your Country</option>
                    <option value="1">USA</option>
                    <option value="2">UK</option>
                    <option value="3">Spain</option>
                    <option value="4">Brazil</option>
                    <option value="5">France</option>
                    <option value="6">Newzeland</option>
                    <option value="7">Australia</option>
                    <option value="8">Bangladesh</option>
                    <option value="9">Turki</option>
                    <option value="10">Chine</option>
                    <option value="11">India</option>
                    <option value="12">Canada</option>
                  </select>
                </div> */}
              </div>
              <div className="interest">
                {/* <div className="custom-select right w-100">
                  <select className="">
                    <option value="0">Your Interests</option>
                    <option value="1">Gaming</option>
                    <option value="2">Fishing</option>
                    <option value="3">Skydriving</option>
                    <option value="4">Swimming</option>
                    <option value="5">Racing</option>
                    <option value="6">Hangout</option>
                    <option value="7">Tranvelling</option>
                    <option value="8">Camping</option>
                    <option value="9">Touring</option>
                    <option value="10">Acting</option>
                    <option value="11">Dancing</option>
                    <option value="12">Singing</option>
                  </select>
                </div> */}
              </div>
              <button type="submit">Find Your Partner</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSearchSection;
